import { render, staticRenderFns } from "./TodoDetailsView.vue?vue&type=template&id=6cec7dfc&scoped=true"
import script from "./TodoDetailsView.vue?vue&type=script&lang=ts"
export * from "./TodoDetailsView.vue?vue&type=script&lang=ts"
import style0 from "./TodoDetailsView.vue?vue&type=style&index=0&id=6cec7dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cec7dfc",
  null
  
)

export default component.exports